/** student/portfolio — API. */
import { http } from '../../_shared/http';
import type { StudentPortfolio } from './types';

export const studentPortfolioApi = {
  fetchMine: () => http.get<StudentPortfolio>('/student-portfolio/my-portfolio'),

  /** Update the authenticated student bio. Empty input clears it (returns null). */
  setBio: (bio: string) => http.patch<{ bio: string | null }>('/student-portfolio/my-bio', { bio }),
};
